export default __webpack_public_path__ + "static/media/Revenue.a54348c5.svg";